import { render } from "./Folder.vue?vue&type=template&id=2794f3f7&scoped=true&bindings={\"shared\":\"options\",\"folder\":\"setup\"}"
import script from "./Folder.vue?vue&type=script&lang=js"
export * from "./Folder.vue?vue&type=script&lang=js"

import "./Folder.vue?vue&type=style&index=0&id=2794f3f7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2794f3f7"

export default script